module.exports = __webpack_public_path__ + "img/proapp-4.ebb87412.webp";